import { backendApi } from "../dynamicBAseQuery";

export const singUpApi = backendApi.injectEndpoints({
    endpoints: (builder) => ({
        SignUp: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: `SignUp`,
                body: { ...args }
            })
        }),
        getWorkCategoryDropDown: builder.query({
            query: () => ({
                method: "GET",
                url: `getWorkCategoryDropDown`,
            })
        }),
         getPositionLevelDropDown: builder.query({
            query: () => ({
                method: "GET",
                url: `getPositionLevelDropDown`,
            })
        }),
         updateWorkCategory: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: `updateWorkCategory`,
                body: { ...args }
            })
        }),
         updateJobPositionLevel: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: `updateJobPositionLevel`,
                body: { ...args }
            })
        }),
         signWorkCategoryDropDown: builder.query({
            query: () => ({
                method: "GET",
                url: `signWorkCategoryDropDown`,
            })
        }),
        signPositionLevelDropDown: builder.query({
            query: () => ({
                method: "GET",
                url: `signPositionLevelDropDown`,
            })
        }),
    })
})

export const {
    useSignUpMutation,
    useGetWorkCategoryDropDownQuery,
    useGetPositionLevelDropDownQuery,
    useUpdateWorkCategoryMutation,
    useUpdateJobPositionLevelMutation,
    useSignWorkCategoryDropDownQuery,
    useSignPositionLevelDropDownQuery
} = singUpApi